import {planStateStatuses} from "../PlanState";

export const PlansTableFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "planned",
        "id": "planned",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "planState",
        "id": "planState",
        "filterFn": (value, filterValue) => planStateStatuses[value].toLowerCase().includes(filterValue.toLowerCase())
    },
]